module.exports = "/assets/data/912faa986e3c248e19bfd1b2601bc307-TS8.data.json";